import { render, staticRenderFns } from "./Arbitration.vue?vue&type=template&id=aaa04138&scoped=true"
import script from "./Arbitration.vue?vue&type=script&lang=js"
export * from "./Arbitration.vue?vue&type=script&lang=js"
import style0 from "./Arbitration.vue?vue&type=style&index=0&id=aaa04138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa04138",
  null
  
)

export default component.exports